import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/tasks/:taskId']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateTask = async ({ taskId, ...payload }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/tasks/${taskId}`, payload);
  return response.data;
};
export default updateTask;
